import { render, staticRenderFns } from "./store.vue?vue&type=template&id=60db8dfc&scoped=true&"
import script from "./store.vue?vue&type=script&lang=js&"
export * from "./store.vue?vue&type=script&lang=js&"
import style0 from "./store.vue?vue&type=style&index=0&id=60db8dfc&lang=scss&scoped=true&"
import style1 from "./store.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60db8dfc",
  null
  
)

export default component.exports